<template>
  <div class="new-booking">
    <page-header
      title="Book New Shipment"
      breadcrumb="Dashboard > Bookings > New Booking Request"
    />
    <div class="card">
      <div class="booking-steps">
        <div
          class="booking-step"
          :class="{ current: formNo == 1, done: formNo > 1 }"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 1">
              <check-mark />
            </span>
            <span v-else>
             1
            </span>
          </div>
          <span class="booking-step__title">Sender</span>
        </div>
        <div
          class="booking-step"
          :class="{ current: formNo == 2, done: formNo > 2 }"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 2">
              <check-mark />
            </span>
            <span v-else>2</span>
          </div>
          <span class="booking-step__title">Receiver</span>
        </div>
        <div
          class="booking-step"
          :class="{ current: formNo == 3, done: formNo > 3 }"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 3">
              <check-mark />
            </span>
            <span v-else>3</span>
          </div>
          <span class="booking-step__title">Shipment</span>
        </div>
        <div
          v-if="shippingRouteType != 'intra-state'"
          class="booking-step"
          :class="{ current: formNo == 4, done: formNo > 4 }"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 4">
              <check-mark />
            </span>
            <span v-else>4</span>
          </div>
          <span class="booking-step__title">Services</span>
        </div>
        <div
          class="booking-step"
          :class="{ current: formNo == 5, done: formNo > 5 }"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 5">
              <check-mark />
            </span>
            <span v-else>5</span>
          </div>
          <span class="booking-step__title">Payment</span>
        </div>
        <div
          class="booking-step"
          :class="{ current: formNo == 6, done: formNo > 6 }"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 6">
              <check-mark />
            </span>
            <span v-else>6</span>
          </div>
          <span class="booking-step__title">Confirmation</span>
        </div>
      </div>

      <keep-alive>
        <component
          :is="currentForm"
          @change-form="formNo++"
          @back-one-form="formNo--"
          :formNo="formNo"
          @add-new-consignee="formNo = 2"
          @save-response="shipperInfo"
        >
        </component>
      </keep-alive>
    </div>
  </div>
</template>

<script>

import ShipperForm from "./ShipperForm";
import ConsigneeForm from "./ConsigneeForm";
import PackageForm from "./PackageForm";
import ShippingDetailsForm from "./ShippingDetailsForm";
import BookingReview from "./BookingReview";
import PaymentForm from "./PaymentForm";
import BookingDirection from "./BookingDirection"
import CheckMark from "./CheckmarkSvg";
import PageHeader from "@/components/UI/NewPageHeader";
export default {
  components: {
    ShipperForm,
    ConsigneeForm,
    PackageForm,
    ShippingDetailsForm,
    BookingReview,
    PaymentForm,
    CheckMark,
    PageHeader,
    BookingDirection
  },
  data() {
    return {
      formNo: 1,
      shippingStep: [{}],
      shippingMethod: "",
      shippingRouteType: ""
    };
  },
  computed: {
    currentForm() {

      
      if (this.formNo == 1) {
        return "shipper-form";
      } else if (this.formNo == 2) {
        return "consignee-form";
      } else if (this.formNo == 3) {
        return "package-form";
      } else if (this.formNo == 4){
        if(this.shippingRouteType == 'inter-state'){
          return "shipping-details-form";
        }else if(this.shippingRouteType == 'intra-state' && this.shippingMethod == 'terminal-to-terminal'){
          return "shipping-details-form";
        }else{
          return "shipping-details-form";
        }
      } else if (this.formNo == 5) {
        return "booking-review";
      }else  if (this.formNo == 6) {
        return "booking-direction";
      } else {
        return "booking-review";
      }
    }
  },
  watch: {
    formNo() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      this.getShippingDetails()
    },
  },
  mounted() {
    if (this.$store.getters.lastCompletedFormNo) {
      this.formNo = this.$store.getters.lastCompletedFormNo + 1;
    }
  },
  methods: {
    shipperInfo(res){
      console.log(JSON.stringify(res,null,2))
    },
    async createUser() {
      try {
        const response = await this.$_createOndemandUser();
        localStorage.setItem("userIdForBookings", response.data.data.user.id);
      } catch (error) {
        this.handleError();
      }
    },
    getShippingDetails(){
      this.shippingMethod = this.$store.state.bookingModule.newBooking.shippingMethod;
      this.shippingRouteType = this.$store.state.bookingModule.newBooking.routeType;
    }
  },
};
</script>

<style lang="scss" scoped>
.card {
  padding: 0;
}

.new-booking {
  --grey: #b7c1cc;
  --amber: #f7b643;
  // margin-bottom: 3rem;
}

// .card {
//   height: 80vh;
//   overflow-y: auto;
// }
// .card::-webkit-scrollbar {
//   width: 0;
// }

.booking-steps {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background: #fffcf7;
  padding: 1rem 5rem;
  // position: fixed;
  // width: 76%;
  // z-index: 999;
  // margin-top: 0;
}

.booking-step.current,
.booking-step.done {
  .booking-step__icon {
    background: var(--amber);
  }

  .booking-step__title {
    font-weight: 500;
  }
}

.booking-step__icon {
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background: var(--grey);
  margin: 0.5rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}

.booking-step__title {
  color: var(--primaryblue);
  font-size: 0.9rem;
}

.label {
  color: var(-primaryblue);
  font-size: 0.9rem;
  font-weight: 500;
}

.button {
  background-color: #fcc210;
  color: var(--primaryblue);
  border: 1px solid #fcc008;
  box-sizing: border-box;
  box-shadow: 0px 6px 10px rgba(221, 144, 9, 0.25);
  border-radius: 2px;
  margin-right: 1.5rem;
}
</style>
